import { api } from '@/lib/api';

/**
 * Build-info wrapper. `cms_core` is the monorepo release tag the running
 * api image was built from (core, api, public and worker all ship from
 * that one tag now), and `built_at` is when that image was built. Both
 * are baked into the image by Drone: since core became a Composer path
 * repository, composer.lock only ever says `dev-main`, so a checkout
 * running outside a CI-built image reports that and no date.
 *
 * cms-admin still has no version of its own — package.json isn't bumped
 * on deploy. Add a field here once there's a real signal to show.
 */
export interface AboutResponse {
    cms_core: string | null;
    built_at: string | null;
}

export function fetchAbout(): Promise<AboutResponse> {
    return api('/api/admin/about');
}
